import { useFormContext } from 'react-hook-form'
import SelectTagInputWithCheckboxes from '@/components/SelectTagInputWithCheckboxes'
import type { EditPostFormData } from '../types'

interface FormPartnersFieldProps {
  items: { id: string; name: string }[]
  loading: boolean
}

export function FormPartnersField({ items, loading }: FormPartnersFieldProps) {
  const { watch, setValue } = useFormContext<EditPostFormData>()
  const value = watch('partners') || []
  return (
    <div className="space-y-2">
      <label className="text-sm">Marca vinculada (opcional):</label>
      <SelectTagInputWithCheckboxes
        value={value}
        onChange={(v) => setValue('partners', v, { shouldDirty: true })}
        placeholder="Pesquisar"
        items={items}
        loading={loading}
        buttonLabel="Adicionar"
      />
    </div>
  )
}
